import * as React from "react";
import { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    DetailsListLayoutMode,
    IColumn,
    Selection,
    SelectionMode,
} from "office-ui-fabric-react/lib/DetailsList";
import { MarqueeSelection } from "office-ui-fabric-react/lib/MarqueeSelection";
import { ShimmeredDetailsList, Stack } from "office-ui-fabric-react";
import { IRenderProps } from "../../orders/providers/Pagination.types";
import { sort, toggleFiltration } from "../../../config/redux/filters/filterActions";
import { storeColumns } from "../columns/storeColumns";
import Pagination from "../providers/Pagination";
import { footer, listContainerS, listS } from "../../clients/components/clientsList.styles";

const StoreList: React.FC = () => {
    const { t } = useTranslation("admin");
    const dispatch = useDispatch();
    const { reload } = useSelector((state: RootStateOrAny) => state.store);

    const [cols, setCols] = useState<IColumn[]>(() => storeColumns(t));

    const footerRef = useRef<HTMLDivElement>(null);

    const selection = useRef(new Selection());

    useEffect(() => {
        setCols(storeColumns(t));
    }, [t]);

    useEffect(() => {
        if (reload) {
            selection.current.selectToKey("", true);
        }
    }, [reload]);

    const onColumnHeaderClick = (_: any, column: any) => {
        const newColumns = cols.slice();
        const currColumn = newColumns.find(c => c.key === column.key)!;
        newColumns.forEach(col => {
            if (col === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                col.isSorted = false;
                col.isSortedDescending = true;
            }
        });
        dispatch(toggleFiltration({ filter: true }));
        dispatch(sort({ column: currColumn }));
        setCols(newColumns);
    };

    return (
        <>
            <Pagination
                footerRef={footerRef}
                render={({ data, loading }: IRenderProps) => (
                    <>
                        <Stack styles={listContainerS}>
                            <MarqueeSelection isEnabled={false} selection={selection.current}>
                                <ShimmeredDetailsList
                                    items={data}
                                    columns={cols}
                                    setKey="items"
                                    layoutMode={DetailsListLayoutMode.justified}
                                    selection={selection.current}
                                    selectionMode={SelectionMode.none}
                                    selectionPreservedOnEmptyClick={true}
                                    usePageCache={true}
                                    styles={listS}
                                    onColumnHeaderClick={onColumnHeaderClick}
                                    enableShimmer={loading}
                                />
                            </MarqueeSelection>
                        </Stack>
                        <div className={footer} ref={footerRef} />
                    </>
                )}
            />
        </>
    );
};

export default StoreList;